import { Component, ElementRef, HostListener, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core'
import { CustomerValidationRequestModel, LinkCardMobileRequestModel, LinkCardRequest02Model } from '../../models/card.model';
import { CardService } from '../../services/card.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { UpdateProfileService } from 'app/modules/update-profile/services/update-profile.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateUtils } from 'app/shared/utility/date-utils';
import { ConstantsKey } from 'app/shared/constant/constants-keys';
import { GTMDataLayerService } from 'app/shared/services/gtmDataLayer.service';
import { UpdateProfileModel } from 'app/modules/update-profile/models/update-profile.model';
import moment from 'moment';
import Swal from 'sweetalert2';

@Component({
  selector: 'link-forex-card',
  templateUrl: './link-esim-card.component.html',
  styleUrls: ['./link-esim-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LinkEsimCardComponent implements OnInit {

  public processType: string = "verification";
  public modalReference: any;
  public kitNumber = '';
  public dateOfBirth = '';
  public consumerNumber:string = '';
  public consumerEmail:string = '';
  public otpField1;
  public otpField2;
  public otpField3;
  public otpField4;
  public otpField5;
  public otpField6 ;
  public maskMobile;
  public maskEmail;
  public mobileOtp;
  public emailOtp;
  public otpSendMessage;
  public optNum1;
  public optNum2;
  public optNum3;
  public optNum4;
  public optNum5;
  public optNum6;
  public otpOption = "";
  public displayTimer: any;
  public showTimer: boolean = false;
  public showResendButton: boolean = false;
  public resendOTPBtnActive: boolean = false;  
  public intervalTimer;
  public cardData;
  public custMobile = "";
  public showLoader: boolean = false;
  public consumerDetail: any;  
  public isPANAvailable: boolean = false;
  public paxId: any;  
  isPANCBChecked: boolean = false;
  public panVerificationErrMsg: any;
  public panCardNumber:string;
  public isDOBAvailable: boolean = false;
  public profilePanNumber: string;
  public profileDOBNumber: any; 
  public cardDetailErrMsg: string;
  public vcipStatusDetails: any;
  public xplorerVcipMessage: string = '';
  public xplorerVcipTitle: string = '';
  isVCIPNow: boolean = false;
  public isVcipCheckPending: boolean = false;

  public updateProfileModel = new UpdateProfileModel();
  @ViewChild("PANDetailModal") PANDetailModal: TemplateRef<any>;
  @ViewChild("errorModal") errorModal: TemplateRef<any>;
  @ViewChild("customerDetailMismatch") customerDetailMismatch: TemplateRef<any>;
  @ViewChild("vcipModalNewUser") vcipModalNewUser: TemplateRef<any>;



  @ViewChild('verifiationCardLinkModal') verifiationCardLinkModal: TemplateRef<any>;

  constructor(public modalService: NgbModal, public cardService: CardService, public toast: ToastrService, private router: Router,
      public gtmPushService: GTMDataLayerService,
    public updateProfileService: UpdateProfileService,) { }

  ngOnInit() {
    this.cardData = JSON.parse(sessionStorage.getItem(ConstantsKey.WSFX_SELECTED_CARDS));

    let consumerData = localStorage.getItem(ConstantsKey.CONSUMER_DATA);
    if(consumerData) {
      consumerData = JSON.parse(consumerData);
      this.custMobile = consumerData["mobile"];
    }
    this.getProfileDetails("page_load");
    if (this.cardData?.card == 'XPLORER_MULTI_CARD') {
      this.isVcipCheckPending = true;
      this.getVCIPStatus();
    }
  }

  // Refresh VCIP status when the user returns from the Video KYC tab
  @HostListener('document:visibilitychange')
  onVisibilityChange() {
    if (document.visibilityState !== 'visible' || this.cardData?.card != 'XPLORER_MULTI_CARD') {
      return;
    }
    if (this.isVcipCheckPending || this.vcipStatusDetails?.vcipStatus == 'ACCEPTED') {
      return;
    }
    this.getVCIPStatus();
  }

  getVCIPStatus(onComplete?: () => void) {
    this.updateProfileService.getVCIPStaus().subscribe((resp => {
      this.isVcipCheckPending = false;
      this.vcipStatusDetails = resp.body;
      this.xplorerVcipMessage = this.getXplorerVcipStatusState().message;
      const status = this.vcipStatusDetails?.vcipStatus;
      if (status == 'NOT_INITIATED' || status == 'INITIATED' ||  status == 'IN_PROGRESS') {
        this.xplorerVcipMessage = ' A quick video call is needed to verify your identity. It takes just a few minutes. Please keep your original PAN card ready.';
        this.xplorerVcipTitle = 'Complete your Video KYC';
      } else if (status == 'PENDING') {
        this.xplorerVcipMessage = "Thank you! We've received your details and are verifying them. We'll notify you once it's done.";
        this.xplorerVcipTitle = 'Your Video KYC is under review';
      } else if (status == 'REJECTED') {
        this.xplorerVcipMessage = "We couldn't verify your details this time. Please try again with good lighting, a stable internet connection, and your original PAN card.";
        this.xplorerVcipTitle = 'Video KYC unsuccessful';
      }
      onComplete?.();
    }), error => {
      this.isVcipCheckPending = false;
      onComplete?.();
    });
  }

  // Xplorer users who are not yet eligible to link see only the VCIP content instead of the link form
  get showOnlyVcipContent(): boolean {
    return !this.isVcipCheckPending && !this.isXplorerLinkAllowed();
  }

  getXplorerVcipStatusState(status?: string): { allowLink: boolean; showAction: boolean; message: string } {
    const vcipStatus = (status || this.vcipStatusDetails?.vcipStatus || '').toUpperCase();
    const defaultMessage = this.vcipStatusDetails?.message || 'Please complete your Video-KYC';

    const states = {
      ACCEPTED: { allowLink: true, showAction: false, message: '' },
      NOT_INITIATED: { allowLink: false, showAction: true, message: defaultMessage },
      IN_PROGRESS: { allowLink: false, showAction: true, message: defaultMessage },
      INITIATED: { allowLink: false, showAction: true, message: defaultMessage },
      PENDING: { allowLink: false, showAction: true, message: defaultMessage },
      REJECTED: { allowLink: false, showAction: true, message: 'Your Video-KYC was not successful. Please re-attempt to continue.' },
      DRAFT: { allowLink: false, showAction: true, message: defaultMessage },
    } as const;

    return states[vcipStatus as keyof typeof states] || {
      allowLink: false,
      showAction: true,
      message: defaultMessage,
    };
  }

  isXplorerLinkAllowed(): boolean {
    if (this.cardData?.card != 'XPLORER_MULTI_CARD') {
      return true;
    }
    const status = (this.vcipStatusDetails?.vcipStatus || '').toUpperCase();
    return !status || this.getXplorerVcipStatusState().allowLink;
  }

  openModalForVCIPNewUser() {
    this.modalReference?.close();
    this.modalReference = this.modalService.open(this.vcipModalNewUser, {
      centered: true,
      size: 'md',
    });
  }

  shouldShowVcipActionButton(): boolean {
    return this.getXplorerVcipStatusState().showAction;
  }

  getXplorerVcipActionLabel(): string {
    const status = (this.vcipStatusDetails?.vcipStatus || '').toUpperCase();
    if (status === 'NOT_INITIATED' || status === 'INITIATED'  ||  status == 'IN_PROGRESS') {
      return 'Start Video KYC';
    } else if (status === 'REJECTED') {
      return 'Retry Video KYC';
    }
    return 'Okay';
  }

  initiateVcip() {
    this.modalReference?.close();
    const status = this.vcipStatusDetails?.vcipStatus;
    if (status == 'NOT_INITIATED' || status == 'REJECTED' || status == 'INITIATED'  ||  status == 'IN_PROGRESS') {
      if (!this.isPANAvailable) {
        this.isVCIPNow = true;
        this.openModalForPANNo();
        return;
      }
      this.redirectToVcip();
    }
  }

  checkXplorerLinkEligibility() {
    this.getVCIPStatus(() => this.onInlineVcipAction());
  }

  onInlineVcipAction() {
    const status = this.vcipStatusDetails?.vcipStatus;
    if (status == 'NOT_INITIATED' || status == 'REJECTED' || status == 'INITIATED' ||  status == 'IN_PROGRESS') {
      this.initiateVcip();
    } else {
      this.router.navigate(['/cards']);
    }
  }

  redirectToVcip() {
    this.showLoader = true;
    this.updateProfileService.getVCIPRedirectionURL().subscribe(
      (resp) => {
        this.showLoader = false;
        var vcipResponse = JSON.parse(JSON.stringify(resp.body));
        window.open(vcipResponse.mobileAutologinUrl, "_blank");
      },
      (error) => {
        this.showLoader = false;
        this.toast.error(JSON.stringify(error.error.message));
      }
    );
  }

  onPanModalProceed() {
    if (this.isVCIPNow) {
      this.validatePanAPI();
    } else {
      this.openModalForCardLink();
    }
  }

 
  getProfileDetails(call_type) {
    this.updateProfileService.getProfileListAll().subscribe(
      (resp) => {
        this.showLoader = false;
        this.consumerDetail = resp.body;

        this.paxId = this.consumerDetail.paxResponse.id;

        // if(this.consumerDetail?.panNumber != null && this.consumerDetail?.panNumber ) {
        //   this.isPANAvailable = true;
        //   this.profilePanNumber = this.consumerDetail?.panNumber; 
        // } 
         if(this.consumerDetail?.paxResponse != null  ) {
          if(this.consumerDetail?.paxResponse?.pan!=null && this.consumerDetail?.paxResponse?.consumer?.pan?.pan) {
            this.isPANAvailable = true;
            this.profilePanNumber = this.consumerDetail?.paxResponse?.consumer?.pan.pan; 
            console.log("PAN NUMBER AVAILABLE ", this.profilePanNumber, "isPANAvailable ", this.isPANAvailable);
          }
          if(this.consumerDetail?.paxResponse?.dob!=null && this.consumerDetail?.paxResponse?.dob) {
              this.profileDOBNumber = DateUtils.ngbDateStructDateConverter(moment(this.consumerDetail.paxResponse.dob).format("YYYY-MM-DD"));
          if(Number.isNaN(this.profileDOBNumber.day)) {
          this.isDOBAvailable = false;
          } else {
          this.isDOBAvailable = true;
          }
          console.log("DOB AVAILABLE ", this.profileDOBNumber, "isDOBAvailable ", this.isDOBAvailable);
          }
        }
        
        // if(this.consumerDetail?.dob != null && this.consumerDetail?.dob) {
        //   this.profileDOBNumber = DateUtils.ngbDateStructDateConverter(moment(this.consumerDetail.paxResponse.dob).format("YYYY-MM-DD"));
        //   if(Number.isNaN(this.profileDOBNumber.day)) {
        //   this.isDOBAvailable = false;
        //   } else {
        //   this.isDOBAvailable = true;
        //   }
        // }

         if(this.consumerDetail?.dob != null && this.consumerDetail?.dob) {
          this.profileDOBNumber = DateUtils.ngbDateStructDateConverter(moment(this.consumerDetail.paxResponse.dob).format("YYYY-MM-DD"));
          if(Number.isNaN(this.profileDOBNumber.day)) {
          this.isDOBAvailable = false;
          } else {
          this.isDOBAvailable = true;
          }
        }

          // if(call_type == "update_pan") {
          //   this.openModalForCardLink();
          // }        
      },
      (error) => {
        this.showLoader = false;
        this.toast.error(error.error.message);
      }
    );
  }
  
 

  formateDateToRequired(dateObj) {
    var requiredDate = dateObj.year + "-" + this.pad(dateObj.month) + "-" + this.pad(dateObj.day);
    return requiredDate;
  }

  pad(n) { return n < 10 ? '0' + n : n }
  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  openModalForCardLink() {

    if (!this.isXplorerLinkAllowed()) {
      this.openModalForVCIPNewUser();
      return;
    }

    if(this.kitNumber && this.kitNumber != "") {
      if(this.isDOBAvailable || (this.dateOfBirth && this.dateOfBirth != "")) {
        if(this.isPANAvailable || (this.panCardNumber != "" && this.validatePANNo(this.panCardNumber))) {

          let dob;
          if(this.isDOBAvailable) {
            dob = new Date(DateUtils.getNgbDateStructToDate(this.profileDOBNumber)).toISOString();
          } else {
            dob = new Date(DateUtils.getNgbDateStructToDate(this.dateOfBirth)).toISOString();
          }


          let requestObj = {
            "kit": this.kitNumber,
            "dob": dob,
            "pan": this.isPANAvailable ? this.profilePanNumber : this.panCardNumber
          }

          let gtmObj = {
            // "kitNo": ,
            "event": "Link card Step1", 
            "dob": dob,
            "cardType": this.cardData.title,
            "mobile": "91"+this.custMobile
          };

          this.gtmPushService.dataLayerPushData(gtmObj);

          this.cardService.verifyKit(requestObj).subscribe(res => {
            console.log("VERIFCATION OF CARD KIT ", res);
            let resObj = res.body;
    
            if(resObj["kitAndDobValid"] == true) {
              this.maskEmail = resObj["email"];
              this.maskMobile = resObj["mobile"];
              this.processType = "VERIFICATION_OPTION";
              this.modalReference = this.modalService.open(this.verifiationCardLinkModal, { centered: true, size: 'sm' })
            } else if(resObj["kitAndDobValid"] == false) {
              //this.toast.error(resObj["message"]);
              if(resObj["message"] == "Invalid Kit Number!") {
                Swal.fire("Invalid", resObj["message"]);
              } else {
                this.cardDetailErrMsg = resObj["message"];
                this.modalReference = this.modalService.open(this.customerDetailMismatch, {
                  centered: true,
                  size: "sm",
                });                
              }
            }
          }, err => {
            if(err.error.message == "Customer details with card details mismatch!") {
              this.cardDetailErrMsg = err.error.message;
              this.modalReference = this.modalService.open(this.customerDetailMismatch, {
                centered: true,
                size: "sm",
              });
            } else {
              //this.toast.error(err.error.message);
              Swal.fire(" Error", err.error.message, "error");

            }

          });

        } else {
          this.toast.error("Please enter valid PAN");
        }
      } else {
        this.toast.error("Please enter Date of Birth");
      }

    } else {
      this.toast.error("Please enter kit No");
    }

    // this.modalReference = this.modalService.open(this.verifiationCardLinkModal, { centered: true, size: 'sm' })

  }

  sendOtpForLinkCard() {

    if(this.otpOption && this.otpOption != '') {

      let requestObj = {
        "mobile": this.otpOption == 'mobile',
        "email": this.otpOption == 'email',
        "kit": this.kitNumber
      };


        let gtmObj = {
          // "kitNo": this.kitNumber,
          "event": "Link card Step2",           
          "verificationMethod": this.otpOption,
          "mobile": "91"+this.custMobile
        };

        this.gtmPushService.dataLayerPushData(gtmObj);
      
      console.log("SEND OTP LINK CARD ", requestObj);

      this.cardService.sendOtpForLinkCard(requestObj).subscribe(res => {
        this.toast.success(res.body.toString());      
      }, err => {

        if(err.status == 200) {
          this.processType = "VERIFY_OTP";
          console.log("VERIFY OTP : ", err);
          this.otpSendMessage = err.error.text;

          // this.showSend = false;
          this.showTimer = true;
          this.timer(0.5);
          this.toast.success(err.error.text);     
          // Swal.fire(" Success", "OTP has been sent successfully", "success");

        } else {
          this.toast.error(err.error.message);
        }



      });
    } else {
      this.toast.error("Please OTP verfication option");    
    }
  }

  verifyOtpForLinkCard() {
    
    if(this.optNum1 && this.optNum1.length == 1 && this.optNum2 && this.optNum2.length == 1 && this.optNum3 && this.optNum3.length == 1 && this.optNum4 && this.optNum4.length == 1  && this.optNum5 && this.optNum5.length == 1 && this.optNum6 && this.optNum6.length == 1 ) {
      let otpNumber = this.optNum1 + this.optNum2 + this.optNum3 + this.optNum4 + this.optNum5 + this.optNum6;

      console.log("OTP NUMBER ", otpNumber);
      let verifyType = "";
      if(this.otpOption == "mobile" ) {
        verifyType = "MOBILE";
      } else if(this.otpOption == "email") {
        verifyType = "EMAIL";
      }

      let dob;
      if(this.isDOBAvailable) {
        dob = new Date(DateUtils.getNgbDateStructToDate(this.profileDOBNumber)).toISOString();
      } else {
        dob = new Date(DateUtils.getNgbDateStructToDate(this.dateOfBirth)).toISOString();
      }



      let requestObj = {
        "verificationType":verifyType,
        "otp": otpNumber,
        "kit": this.kitNumber,
        "dob": dob,
        "pan": this.isPANAvailable ? this.profilePanNumber : this.panCardNumber
      };
      this.cardService.verifyOtpForLinkCard(requestObj).subscribe(res => {
        

      }, err => {

        if(err.status == 200) {
          this.closeLinkModal();
          console.log("============================", err)
          this.toast.success(err.error.text);
          this.router.navigate(['/my-card']);        
        } else {
          this.toast.error(err.error.message);
        }


      });

    } else {
      this.toast.error("Please enter OTP");
    }


  }

  closeLinkModal() {
    this.modalReference.close();
  }

  /* gotoNextField(nextElement: HTMLElement) {
    console.log("NEXT ELEMENT == ", nextElement);
    nextElement.focus();
  }

  onInputChange(e, prev, next) {
    const target = e.target;
    const val = target.value;

    if (isNaN(val)) {
        target.value = "";
        return;
    }

    if (val != "") {  
        const next = target.nextElementSibling;
        if (next) {
            next.focus();
        }
    }
  }

  keyUpEvent(e, prev, next) {
    const target = e.target;
    const key = e.key.toLowerCase();
    if (key == "backspace" || key == "delete") {
      target.value = "";
      const prev = target.previousElementSibling;
      if (prev) {
          prev.focus();
      }
      // return;
  }

  } */


  otpInputChange(e, index, next) {

    let inputValue = e.target.value.trim();
    
    if (!/^\d$/.test(inputValue)) {
      e.target.value = "";
      return;
    }

    if (inputValue && index < 6) {
      next.focus();
    }

    if (index === 5 && inputValue) {
      next.focus();
    }

  }

  otpKeyDownChange(e, index, prev) {
    if (!e.target.value && e.key === "Backspace" && index > 1) {
      prev.focus();
    }
  }

  
  numberOnly(e) {
    var charCode = e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57))
        return false;
    return true;
  }  

  timer(minute) {
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 30;

    const prefix = minute < 10 ? "0" : "";

    if(this.intervalTimer) {
      clearInterval(this.intervalTimer);
    }

    this.intervalTimer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 29;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.displayTimer = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        console.log("finished");
        this.showTimer = false;
        this.showResendButton = true; // Show Resend OTP button
        clearInterval(this.intervalTimer);
      }
    }, 1000);
  }

  getPanName() {
    this.updateProfileModel.pan = this.updateProfileModel.pan.toUpperCase();
    if (
      this.updateProfileModel.pan &&
      this.updateProfileModel.pan.length == 10 &&
      this.validatePANNo(this.updateProfileModel.pan)
    ) {
      this.showLoader = true;
      this.updateProfileService
        .getPANName(this.updateProfileModel.pan)
        .subscribe(
          async (resp) => {
            console.log(resp.body);
            var panResponse = JSON.parse(JSON.stringify(resp.body));
            this.showLoader = false;
            if (panResponse.panStatus == "E") {
              if (
                panResponse.fullName &&
                panResponse.fullName != "null" &&
                panResponse.fullName != ""
              ) {
                this.updateProfileModel.name = panResponse.fullName;
              } else {
                this.updateProfileModel.name = "";
              }

              if (
                panResponse.dob &&
                panResponse.dob != "null" &&
                panResponse.dob != ""
              ) {
                this.updateProfileModel.dob =
                  DateUtils.ngbDateStructDateConverter(panResponse.dob);
              }
            } else if (
              panResponse.flatPan.status ==
              "Record Not Found in ITD Database/Invalid PAN"
            ) {
              this.updateProfileModel.name = "";
              this.updateProfileModel.dob = "";
              this.toast.error("Invalid Pan");
            } /* else {
          this.toast.error(panResponse.flatPan.status);
        } */
          },
          (error) => {
            this.showLoader = false;
            this.updateProfileModel.name = "";
            // this.updateProfileModel.dob = '';
            this.toast.error(error.error.message);
          }
        );
    }
  }

  validatePANNo(panNo) {
    const regex = /^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$/;
    if (!regex.test(panNo)) {
      return false;
    } else {
      return true;
    }
  }  

  openModalForPANNo() {
    this.modalReference?.close();
    this.modalReference = this.modalService.open(this.PANDetailModal, {
      centered: true,
      size: "sm",
      backdrop: 'static'
    });
  }  

  alphaNumberOnly(e) {
    // Accept only alpha numerics, not special characters
    var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }
    e.preventDefault();
    return false;
  }  

  validatePanAPI() {
    if (this.validatePanDetails()) {
      this.showLoader = true;
      let dateofBirth = DateUtils.getNgbDateStructToDatev2(
        this.updateProfileModel.dob
      );

      this.updateProfileService
        .validatePAN(
          this.updateProfileModel.pan,
          this.updateProfileModel.name,
          dateofBirth
        )
        .subscribe(
          async (resp) => {
            console.log(resp.body);
            let isPanSuccess;
            var panResponse = JSON.parse(JSON.stringify(resp.body));
            this.showLoader = false;
            if (panResponse.panStatus == "E") {
              // && panResponse.fullName != "" && panResponse.dob != ""
              isPanSuccess = 'Yes';
              this.updatePAN();
            } else if (panResponse.panStatus != "E") {
              isPanSuccess = 'No';
              this.panVerificationErrMsg = "Please enter valid PAN";
              this.openErrorModal();
            } /* else if (panResponse.fullName == "") {
        this.panVerificationErrMsg = "Please enter Name as per PAN";
        this.openErrorModal();
      }
      else if (panResponse.dob == "") {
        this.panVerificationErrMsg = "Please enter valid Date of Birth";
        this.openErrorModal();
      } */


                    let gtmObj = {
                      event: "pan_Verification",
                      verfication_success: isPanSuccess == 'Yes' ? 'Yes' : 'No' ,
                      verfication_failed: isPanSuccess == 'No' ? 'Yes' : 'No',
                      later: 'Y',
                      mobile: "91"+this.consumerDetail.mobile,
                      email: this.consumerDetail.email,
                    };
                    this.gtmPushService.dataLayerPushData(gtmObj);

          },
          (error) => {
            this.showLoader = false;
            this.toast.error(error.error.message);
          }
        );
    }
  }  

  updatePAN() {
    this.showLoader = true;
    // var consumerDataLocal = localStorage.getItem(ConstantsKey.CONSUMER_DATA);
    // var consumerData = JSON.parse(consumerDataLocal);
    // if (consumerData != null && consumerData.mobile != null) {
    //   this.updateProfileModel.mobile = consumerData.mobile;
    //   this.updateProfileModel.email = consumerData.email;
    //   this.updateProfileModel.consumerId = consumerData.id;
    // } else {
    //   this.updateProfileModel.mobile = this.consumerDetail.mobile;
    //   this.updateProfileModel.email = this.consumerDetail.mobile;
    //   this.updateProfileModel.consumerId = this.consumerDetail.mobile;
    // }
    this.updateProfileModel.mobile = this.consumerDetail.mobile;
    this.updateProfileModel.email = this.consumerDetail.email;
    let dateofBirth = DateUtils.getNgbDateStructToDate(
      this.updateProfileModel.dob
    );
    this.updateProfileModel.dob = dateofBirth;
    console.log("pax model>>>> ", JSON.stringify(this.updateProfileModel));
    this.updateProfileService
      .updateProfileDetails(this.paxId, this.updateProfileModel)
      .subscribe(
        async (resp) => {
          this.toast.success("Your PAN details are updated successfully!");
          this.showLoader = false;
          this.modalReference.close();
          this.continueVcipAfterPanUpdate();
        },
        (error) => {
          this.showLoader = false;
          if (error.status == 200) {
          this.toast.success("Your PAN details are updated successfully!");
          this.showLoader = false;            
            this.modalReference.close();
            this.getProfileDetails('update_pan');
            this.continueVcipAfterPanUpdate();
          } else {
            this.toast.error("Something went wrong ! Please try again !");
          }
        }
      );
  }  

  continueVcipAfterPanUpdate() {
    if (this.isVCIPNow) {
      this.isVCIPNow = false;
      this.isPANAvailable = true;
      this.redirectToVcip();
    }
  }

  validatePanDetails() {
    if (!(this.updateProfileModel.pan != null)) {
      this.toast.error("Please enter your PAN");
      return false;
    }
    if (!this.validatePANNo(this.updateProfileModel.pan)) {
      this.toast.error("Please enter valid PAN");
      return false;
    }
    if (!(this.updateProfileModel.name != null)) {
      this.toast.error("Please enter name as per PAN");
      return false;
    }
    if (!this.isPANCBChecked) {
      this.toast.error("Please check the declaration of PAN");
      return false;
    }
    if (!(this.updateProfileModel.dob != null)) {
      this.toast.error("Please select your Date of Birth ");
      return false;
    }

    return true;
  }  

  openErrorModal() {
    this.modalReference?.close();
    this.modalReference = this.modalService.open(this.errorModal, {
      centered: true,
      size: "sm",
    });
  }  

  goToSupport() {
    this.modalReference?.close();
    this.router.navigate(['/support']);        
  }

}
